// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-footer {
  box-shadow: 1px 2px 30px 0px #000;
  transition: height 0.5s ease-in-out;
}
.item-footer .item-box {
  max-width: 1300px;
  margin: auto;
}
.item-footer .image-box ::ng-deep app-img img {
  height: 65px;
  max-width: 60px;
}
.item-footer ion-item {
  margin: 0 2px;
}
.item-footer ion-label {
  padding: 0 2px;
}
.item-footer ion-card-title {
  font-size: 15px;
  white-space: pre-line;
  max-height: 28px;
  overflow: hidden;
}
.item-footer ion-card-subtitle {
  font-size: 11px;
}
.item-footer ion-card-subtitle p {
  font-size: 11px;
  margin: 0;
}
.item-footer ion-buttons {
  max-width: 400px;
}
.item-footer ion-buttons ion-button {
  width: 100%;
  margin: 2px;
}
.item-footer ion-buttons .props-btn {
  max-width: 70px;
  white-space: pre-line;
  font-size: 11px;
}
.item-footer .added-to-cart ion-icon.success {
  color: green;
  font-size: 40px;
  margin: 0 15px;
}
.item-footer .added-to-cart h3 {
  font-size: 17px;
  font-weight: bold;
  margin: 0;
}
.item-footer .added-to-cart ion-buttons.full-width {
  width: 90px;
}
.item-footer .ion-no-padding {
  --inner-padding-bottom: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
  --inner-padding-top: 0;
}
.item-footer .close-btn {
  background: var(--button-b-background);
  color: var(--button-b-text);
  width: 34px;
  font-size: 23px;
  position: absolute;
  z-index: 20;
  right: 0;
  top: 10px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  height: 45px;
  padding: 10px 5px;
  box-shadow: 0px 0px 4px 0px #5a5a5a;
}

.item-footer.big.shown {
  height: 95px;
}

.item-footer.shown {
  height: 65px;
}

.item-footer.shown.agent {
  height: -moz-fit-content !important;
  height: fit-content !important;
}

.item-footer.hidden {
  height: 0;
}

@media screen and (min-width: 1000px) {
  .item-footer.big.shown {
    height: 110px;
  }
  .item-footer .subtitle {
    font-size: 1.2rem;
  }
  .item-footer ion-buttons ion-button {
    width: 100px;
    height: 40px;
  }
  .item-footer ion-buttons .xButton {
    width: 70px;
    height: 70px;
  }
  .item-footer .image-box ::ng-deep app-img img {
    height: 70px;
    min-width: 70px;
  }
}
.close-btn {
  --border-radius: 10px 10px 0 0;
  --box-shadow: 0;
  margin: 4px 20px;
  width: 200px;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/components/item-footer/item-footer.component.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EAYA,mCAAA;AANF;AAQE;EACE,iBAAA;EACA,YAAA;AANJ;AAUI;EACE,YAAA;EACA,eAAA;AARN;AAYE;EACE,aAAA;AAVJ;AAaE;EACE,cAAA;AAXJ;AAcE;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;AAZJ;AAeE;EACE,eAAA;AAbJ;AAeI;EACE,eAAA;EACA,SAAA;AAbN;AAiBE;EACE,gBAAA;AAfJ;AAiBI;EACE,WAAA;EACA,WAAA;AAfN;AAkBI;EACE,eAAA;EACA,qBAAA;EACA,eAAA;AAhBN;AAuBI;EACE,YAAA;EACA,eAAA;EACA,cAAA;AArBN;AAwBI;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AAtBN;AAyBI;EACE,WAAA;AAvBN;AA2BE;EACE,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,sBAAA;AAzBJ;AA4BE;EACE,sCAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EAEA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,4BAAA;EACA,+BAAA;EAEA,YAAA;EACA,iBAAA;EACA,mCAAA;AA7BJ;;AAiCA;EAEE,YAAA;AA/BF;;AAkCA;EAEE,YAAA;AAhCF;;AAmCA;EAEE,mCAAA;EAAA,8BAAA;AAjCF;;AAoCA;EAEE,SAAA;AAlCF;;AAsCA;EAEE;IAEE,aAAA;EArCF;EAyCE;IACE,iBAAA;EAvCJ;EA2CI;IACE,YAAA;IACA,YAAA;EAzCN;EAiDI;IACE,WAAA;IACA,YAAA;EA/CN;EAoDI;IACE,YAAA;IACA,eAAA;EAlDN;AACF;AAwDA;EACI,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAtDJ","sourcesContent":[".item-footer {\n  box-shadow: 1px 2px 30px 0px #000;\n  //\n  //-webkit-transition: opacity 0.5s ease-in-out;\n  //-moz-transition: opacity 0.5s ease-in-out;\n  //-ms-transition: opacity 0.5s ease-in-out;\n  //-o-transition: opacity 0.5s ease-in-out;\n  //transition: opacity 0.5s ease-in-out;\n\n  -webkit-transition: height 0.5s ease-in-out;\n  -moz-transition: height 0.5s ease-in-out;\n  -ms-transition: height 0.5s ease-in-out;\n  -o-transition: height 0.5s ease-in-out;\n  transition: height 0.5s ease-in-out;\n\n  .item-box {\n    max-width: 1300px;\n    margin: auto;\n  }\n\n  .image-box {\n    ::ng-deep app-img img {\n      height: 65px;\n      max-width: 60px;\n    }\n  }\n\n  ion-item {\n    margin: 0 2px;\n  }\n\n  ion-label {\n    padding: 0 2px;\n  }\n\n  ion-card-title {\n    font-size: 15px;\n    white-space: pre-line;\n    max-height: 28px;\n    overflow: hidden;\n  }\n\n  ion-card-subtitle {\n    font-size: 11px;\n\n    p {\n      font-size: 11px;\n      margin: 0;\n    }\n  }\n\n  ion-buttons {\n    max-width: 400px;\n\n    ion-button {\n      width: 100%;\n      margin: 2px;\n    }\n\n    .props-btn {\n      max-width: 70px;\n      white-space: pre-line;\n      font-size: 11px;\n    }\n  }\n\n  .added-to-cart {\n    //padding: 0 20px;\n\n    ion-icon.success {\n      color: green;\n      font-size: 40px;\n      margin: 0 15px;\n    }\n\n    h3 {\n      font-size: 17px;\n      font-weight: bold;\n      margin: 0;\n    }\n\n    ion-buttons.full-width {\n      width: 90px;\n    }\n  }\n\n  .ion-no-padding {\n    --inner-padding-bottom: 0;\n    --inner-padding-end: 0;\n    --inner-padding-start: 0;\n    --inner-padding-top: 0;\n  }\n\n  .close-btn {\n    background: var(--button-b-background);\n    color: var(--button-b-text);\n    width: 34px;\n    font-size: 23px;\n\n    position: absolute;\n    z-index: 20;\n    right: 0;\n    top: 10px;\n\n    border-top-left-radius: 30px;\n    border-bottom-left-radius: 30px;\n\n    height: 45px;\n    padding: 10px 5px;\n    box-shadow: 0px 0px 4px 0px #5a5a5a;\n  }\n}\n\n.item-footer.big.shown {\n  //opacity: 1;\n  height: 95px;\n}\n\n.item-footer.shown {\n  //opacity: 1;\n  height: 65px;\n}\n\n.item-footer.shown.agent {\n  //opacity: 1;\n  height: fit-content !important;\n}\n\n.item-footer.hidden {\n  //opacity: 0;\n  height: 0;\n}\n\n\n@media screen and (min-width: 1000px) {\n\n  .item-footer.big.shown {\n    //opacity: 1;\n    height: 110px;\n  }\n  .item-footer {\n\n    .subtitle {\n      font-size: 1.2rem;\n    }\n\n    ion-buttons {\n      ion-button {\n        width: 100px;\n        height: 40px;\n      }\n\n      .button-a, .button-a ion-icon {\n        //font-size: 1rem !important;\n        //font-weight: bolder;\n      }\n\n      .xButton {\n        width: 70px;\n        height: 70px;\n      }\n    }\n\n    .image-box {\n      ::ng-deep app-img img {\n        height: 70px;\n        min-width: 70px;\n      }\n    }\n  }\n\n}\n\n.close-btn{\n    --border-radius: 10px 10px 0 0;\n    --box-shadow: 0;\n    margin: 4px 20px;\n    width: 200px;\n    height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
